import PortalIdParser from 'PortalIdParser';
const getBaseUrl = () => '/contacts';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const navigateToUrl = url => {
  window.location.href = url;
};